import React from 'react';
import DashboardEmbed from './DashboardEmbed';

function Dashboards({ clientName }) {
  return (
    <div className="dashboard-container">
      <h2>{clientName} Claims Overview</h2>
      <DashboardEmbed clientName={clientName} />
    </div>
  );
}

export default Dashboards;
